'use strict';

export default class AddConfController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.newConf = {};
  }

  $onInit() {
    this.getApp();
  }

  getApp() {
    this.$http.get('/api/apks/' + this.$stateParams.id).then(response => {
      this.app = response.data;
      this.newConf.pkg = this.app.pkg;
      this.newConf.versionCode = this.app.versionCode;
    });
  }

  add() {
    this.newConf.app = this.$stateParams.id;
    this.$http.post(`api/AppConfs`, this.newConf).then(response => {
      this.$state.go('appstore.show', {id: this.$stateParams.id});
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/appstore/addConf/addConf.controller.js